import React from 'react';
import { getIconPath, isCanada } from '../../../../../../../utils';
import Anchor from '../../../../../../common/atoms/Anchor';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Image from '../../../../../../common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import MyOffersCoupons from '../../MyOffersCoupons';
import styles from '../styles/RewardsAndOffersTile.style';
import AccountCommonLabels, {
  CHECKOUT_LABELS,
  GLOBAL_LABELS,
} from '../../../labels/AccountCommon.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';

const RewardsAndCouponsTile = (props) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, AccountCommonLabels);
  const { className, onDrawerClose } = props;
  const couponTitle = isCanada()
    ? renderLabel(globalLabels?.placeRewards?.lbl_my_coupon_title, 'lbl_my_coupon_title')
    : renderLabel(
        checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
        'lbl_coupon_collapsible_header'
      );
  return (
    <BodyCopy component="div" className={`${className} my-wallet-section`}>
      <BodyCopy component="div" className="coupon-status-heading">
        <div className="coupon-status-left">
          <div className="coupon-status-logo">
            <Image src={getIconPath('offers-wallet')} className="coupon-icon" />
          </div>
          <span className="my-wallet-heading">{couponTitle}</span>
        </div>
        <Anchor
          to={'/account?id=wallet'}
          asPath={'/account/wallet'}
          className="wallet-view-all"
          target={'_self'}
          dataLocator={'accountverview-earnExtaPointTitle-viewallcta'}
          useRouterNavigation
        >
          {renderLabel(globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
        </Anchor>
      </BodyCopy>

      <BodyCopy component="div" className="coupon-tile-main">
        <MyOffersCoupons closedOverlay={onDrawerClose} isAccountDashboard />
      </BodyCopy>
    </BodyCopy>
  );
};

export default withStyles(RewardsAndCouponsTile, styles);
export { RewardsAndCouponsTile as RewardsAndCouponsTileVanilla };
